import { useAppDispatch } from "Hooks/useRedux";

import { setAppData } from "Redux/appSlice";
import { closeOperation } from "Redux/operationSlice";
import { clearPoints } from "Redux/pointsSlice";
import { starDashboardVisibility } from "Redux/servicesSlice";
import { clearStations, makeInvisible, selectStationStar } from "Redux/stationsSlice";

export default function useCancelOperation() {
  const dispatch = useAppDispatch();

  const cancelOperation = () => {
    dispatch(closeOperation());
    dispatch(clearStations());
    dispatch(clearPoints());
    dispatch(makeInvisible());
    dispatch(setAppData({ path: null }));
    dispatch(starDashboardVisibility(false));
    dispatch(selectStationStar({ starStation: {}, visible: false }));
  };

  return { cancelOperation };
}
